import type { TopPerformer } from '../types'
import { getScoreColor } from '../types'
import { cn } from '@/lib/utils'

interface TopPerformersCardProps {
  performers: TopPerformer[]
}

const rankColors: Record<number, string> = {
  1: 'bg-amber-400 text-white',
  2: 'bg-gray-400 text-white',
  3: 'bg-amber-600 text-white',
}

export function TopPerformersCard({ performers }: TopPerformersCardProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-4">
        Top Performers
      </h3>

      <table className="w-full">
        <thead>
          <tr className="text-xs text-gray-500 uppercase">
            <th className="text-left font-medium pb-2">CSR</th>
            <th className="text-right font-medium pb-2">Calls</th>
            <th className="text-right font-medium pb-2">Score</th>
          </tr>
        </thead>
        <tbody>
          {performers.map((performer) => (
            <tr key={performer.rank} className="border-t border-gray-100">
              <td className="py-2">
                <div className="flex items-center gap-2">
                  <span
                    className={cn(
                      'w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold',
                      rankColors[performer.rank] || 'bg-gray-200 text-gray-600'
                    )}
                  >
                    {performer.rank}
                  </span>
                  <span className="text-sm font-medium text-gray-900">
                    {performer.name}
                  </span>
                </div>
              </td>
              <td className="text-right text-sm text-gray-600 py-2">
                {performer.calls}
              </td>
              <td className="text-right py-2">
                <span
                  className={cn(
                    'inline-flex items-center justify-center w-10 h-6 rounded text-xs font-bold',
                    getScoreColor(performer.score)
                  )}
                >
                  {performer.score}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
